export const isNextDev = process.env.NODE_ENV === 'development';
export const isFabricDev = process.env.REACT_APP_ENV === 'develop';
export const isFabricProd = process.env.REACT_APP_ENV === 'production';
export const fabricEnv = process.env.REACT_APP_ENV!;
export const inAppBrowserDebug = process.env.NEXT_PUBLIC_IN_APP_BROWSER_DEBUG === 'true';

export const CURRENT_URL =
  typeof window !== 'undefined'
    ? window.location.origin
    : (process.env.NEXT_PUBLIC_WEBSITE_URL ??
      (process.env.NEXT_PUBLIC_VERCEL_URL
        ? `https://${process.env.NEXT_PUBLIC_VERCEL_URL}`
        : 'http://localhost:3000'));

export const isDebugEnabled =
  process.env.REACT_APP_DEBUG === 'true' || process.env.NEXT_PUBLIC_APP_DEBUG === 'true';

export const envLinks = {
  desktopAppDownloadUrl:
    process.env.NEXT_PUBLIC_DESKTOP_APP_DOWNLOAD_URL || 'https://dl.todesktop.com/220930m1ahpjvoh',
};

export const isVercelPreview = /^https:\/\/fabric(?:-\w+)+-fabric-vercel.vercel.app$/gm.test(
  CURRENT_URL,
);
export const APP_STORE_URL =
  process.env.NEXT_PUBLIC_APP_STORE_URL ||
  'https://apps.apple.com/us/app/fabric-save-anything/id1457899280';
export const PLAY_STORE_URL =
  process.env.NEXT_PUBLIC_PLAY_STORE_URL ||
  'https://play.google.com/store/apps/details?id=so.fabric.mobile';

export const DISCORD_INVITE_URL =
  process.env.NEXT_PUBLIC_DISCORD_INVITE_URL || 'https://discord.gg/kqnedKrSU8';
